import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';  // ✅ Fixed import
import ReactGA from 'react-ga4';  // ✅ Add Google Analytics
import * as Sentry from '@sentry/react';
import App from './App.tsx';
// Service Worker disabled - using email notifications only
// import { registerServiceWorker } from '../utils/registerServiceWorker.ts';
import './index.css';

// ============= SENTRY ERROR MONITORING =============
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.MODE; // 'development' or 'production'

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions in dev, reduce in prod
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% when errors occur
    
    // Don't send errors in development
    enabled: ENVIRONMENT === 'production',
    
    beforeSend(event) {
      // Don't send errors from localhost in production builds
      if (window.location.hostname === 'localhost') {
        return null;
      }
      return event;
    },
  });
  
  console.log('✅ Sentry initialized');
} else {
  console.warn('⚠️ Sentry DSN not found - error monitoring disabled');
}


// ============= GOOGLE ANALYTICS INITIALIZATION =============
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
  console.log('✅ Google Analytics initialized:', GA_MEASUREMENT_ID);
} else {
  console.warn('⚠️ Google Analytics measurement ID not found in .env');
}

// ============= RENDER APP =============
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Analytics />  {/* Vercel Analytics */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// ============= SERVICE WORKER DISABLED =============
// Service worker disabled in favor of email notifications only
// Email notifications are handled server-side via backend email service
// This provides better reliability and user experience
console.log('📧 Email notifications enabled - Service Worker disabled');